import React, { useEffect, useState } from "react";
import Toster from "../Toster/Toster";
import { useSelector } from "react-redux";

function GlobalMessage() {
  const { error } = useSelector((state) => state.dcoi);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (error) {  // ✅ Only show the message if there's an actual error
      setOpen(true);
    }
  }, [error]);

  return error ? <Toster message={error} severity={"error"} alert={open} setAlert={setOpen} /> : null;
}

export default GlobalMessage;
